import Renderer from "@wielink/datatables/Renderers/Renderer";

class ActionRenderer extends Renderer {
	render() {
		let formatter = Intl.NumberFormat('nl-NL', {
			style: 'currency',
			currency: 'EUR',
		});

		return formatter.format(this.data);
	}
}

export default ActionRenderer;